import TemplateView from '../../../TemplateView'
import ScrollableContainer from '../../../util/ScrollableContainer'
import WorkflowStatusTypeWithCheckboxNode from "./WorkflowStatusTypeWithCheckboxNode";
import WorkflowStatusWithCheckboxNode from "./WorkflowStatusCheckboxNode";
import WorkflowStatusList from "../WorkflowStatusList";
import {arrayToSet} from "../../../atUtils";
import _ from 'underscore'

export class WorkflowStatusFilter extends TemplateView {
    constructor({
        onChangeSelectedItems = () => {}
    }) {
        super(null)

        this.state = {
            selection: {
                statusIds: arrayToSet([]),
                statusTypes: arrayToSet([])
            },
            statuses: []
        }

        this.groupNodes = {};
        this.statusNodes = {};

        this.onChangeSelectedItems = onChangeSelectedItems

        this.onStatePropertyChanged("statuses", () => {this._renderList()})
        this.onStatePropertyChanged("selection", () => {this._updateSelection()})
    }

    templateHtml() {
        return '<div class="workflowStatus_components_workflowStatusFilter"></div>'
    }

    update() {
        super.update()
        if (!!this.scrollableContainer)
            this.scrollableContainer.forceUpdate()
    }

    show() {
        super.show()
        this.update()
    }

    _renderList() {
        this.$el.empty()
        this.groupNodes = {};
        this.statusNodes = {};

        this.scrollableContainer = new ScrollableContainer(
            null,
            new WorkflowStatusList({
                groupRenderer: ($el, type) => {
                    this.groupNodes[type] = new WorkflowStatusTypeWithCheckboxNode(
                        type,
                        (type, checked) => this._changeGroupSelection(type, checked)
                    ).init($el);
                },
                statusRenderer: ($el, status) => {
                    this.statusNodes[status.id] = new WorkflowStatusWithCheckboxNode(
                        status,
                        (status, checked) => this._changeNodeSelection(status, checked)
                    ).init($el);
                }
            })
        )
        this.scrollableContainer.init(this.$el).setState({
            statuses: this.state.statuses
        })

        this._updateSelection();
    }

    _changeGroupSelection(type, checked) {
        let statusIds = _.clone(this.state.selection.statusIds);
        let statusTypes = _.clone(this.state.selection.statusTypes);
        for (let i = 0; i < this.state.statuses.length; ++i) {
            // remove selection from all statuses under this type
            const status = this.state.statuses[i];
            if (status.type === type && statusIds[status.id]) {
                delete statusIds[status.id];
            }
        }
        if (checked)
            statusTypes[type] = true;
        else if (statusTypes[type])
            delete statusTypes[type];

        this.setState({
            selection: {
                statusIds: statusIds,
                statusTypes: statusTypes,
            }
        });
        this._handleChangeSelectedItems()
    }

    _changeNodeSelection(status, checked) {
        let statusIds = _.clone(this.state.selection.statusIds);
        let statusTypes = _.clone(this.state.selection.statusTypes);

        if (!checked && statusTypes[status.type]) {
            // remove selection from group and add selection for all nodes
            for (let i = 0; i < this.state.statuses.length; ++i) {
                const currentStatus = this.state.statuses[i];
                if (currentStatus.type === status.type) {
                    statusIds[currentStatus.id] = true;
                }
            }
            delete statusTypes[status.type];
        }

        if (checked)
            statusIds[status.id] = true;
        else if (statusIds[status.id])
            delete statusIds[status.id];

        this.setState({
            selection: {
                statusIds: statusIds,
                statusTypes: statusTypes,
            }
        });
        this._handleChangeSelectedItems()
    }

    _handleChangeSelectedItems = () => {
        this.onChangeSelectedItems({
            statusIds: Object.keys(this.state.selection.statusIds),
            statusTypes: Object.keys(this.state.selection.statusTypes),
        })
    }

    _updateSelection() {
        for (const type in this.groupNodes) {
            const checked = !!this.state.selection.statusTypes[type];
            this.groupNodes[type].setState({
                checked: checked
            });
        }

        for (let i = 0; i < this.state.statuses.length; ++i) {
            const status = this.state.statuses[i];
            const checked = !!this.state.selection.statusTypes[status.type] ||
                            !!this.state.selection.statusIds[status.id];
            this.statusNodes[status.id].setState({
                checked: checked
            });
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/WorkflowStatusFilter.js